import * as React from 'react'
import {useSelector} from 'react-redux'

import {messageTypes} from '../constants'
import detailsSlice from '../detailsSlice'
import {
  selectChannelId,
  selectMessageName,
  selectMessageType,
  selectPushId,
} from '../selectors'
import {useInProductSupportDispatch} from '../store'
import AdditionalSelect from './AdditionalSelect'
import AdditionalTextInput from './AdditionalTextInput'

const ApiAdditionalFields: React.FC = () => {
  const dispatch = useInProductSupportDispatch()

  const pushId = useSelector(selectPushId)
  const channelId = useSelector(selectChannelId)
  const messageType = useSelector(selectMessageType)
  const messageName = useSelector(selectMessageName)

  const updatePushId = (newPushId: string): void => {
    dispatch(detailsSlice.actions.updateDetails({pushId: newPushId}))
  }

  const updateChannelId = (newChannelId: string): void => {
    dispatch(detailsSlice.actions.updateDetails({channelId: newChannelId}))
  }

  const updateMessageType = (newMessageType: string): void => {
    dispatch(detailsSlice.actions.updateDetails({messageType: newMessageType}))
  }

  const updateMessageName = (newMessageName: string): void => {
    dispatch(detailsSlice.actions.updateDetails({messageName: newMessageName}))
  }

  return (
    <>
      <AdditionalTextInput
        name="Push ID"
        value={pushId}
        onChange={updatePushId}
        helperLink="https://support.airship.com/hc/en-us/articles/213491163-How-to-find-the-Push-ID"
      />
      <AdditionalTextInput
        name="Channel ID"
        value={channelId}
        onChange={updateChannelId}
        helperLink="https://docs.airship.com/guides/messaging/user-guide/audience/identifiers/#find-a-channel-id"
      />
      <AdditionalSelect
        name="Message type"
        selected={messageType}
        onSelect={updateMessageType}
        items={messageTypes}
        defaultItemText="Select message type"
        optionalLabel
      />
      <AdditionalTextInput
        name="Message name"
        value={messageName}
        onChange={updateMessageName}
      />
    </>
  )
}

export default ApiAdditionalFields
